import { useCallback, useState } from "react";
import TextingPanelUsage from "../../../components/CreatorDashboard/TextingPanelUsage";
import { Colors } from "../../../utils/colors";
import MassTextPanel from "../../../components/CreatorDashboard/MassTexts/MassTextPanel";
import { TabPanel } from "../../../components/FullEventSubComponents/TabPanel";
import MarkitPlusActionButton from "../../../components/Subscription/MarkitPlusActionButton";
import CreatorModePanelWrapper from "../../../components/CreatorDashboard/CreatorModePanelWrapper";
import CampaignsListPanel from "../../../components/CreatorDashboard/Campaigns/CampaignsListPanel";
import { useLocation, useNavigate } from "react-router-dom";
import { onCampaignNavigatePath } from "../../../utils/navigationUtils";
import {
  MassTextSelectedType,
  MassTextsWrapperType,
} from "../../../components/CreatorDashboard/MassTexts/MassTextWrapperManager";
import AutomationsListPanel from "../../../components/CreatorDashboard/Campaigns/AutomationsListPanel";
import TextingSettingsPanel from "../../../components/CreatorDashboard/Campaigns/TextingSettingsPanel";
import { OnboardingFlowType } from "@markit/common.types";
import OnboardingFlowDot from "../../../components/Onboarding/OnboardingFlowDot";
import RectangleButtonCreatorPanel from "../../../components/Buttons/RectangleButtonCreatorPanel";

export enum TextingPanelTabs {
  CAMPAIGNS = 0,
  AUTOMATIONS = 1,
  TEXTING_USAGE = 2,
  SETTINGS = 3,
}

const TextingPanel = () => {
  const navigate = useNavigate();
  const { initialTabValue } = useLocation().state || {};
  const [tabValue, setTabValue] = useState(
    initialTabValue || TextingPanelTabs.CAMPAIGNS
  );
  const [selectedTextType, setSelectedTextType] =
    useState<MassTextSelectedType>({ massText: undefined, isVisible: false });

  const styles = {
    textingPanelMainContentContainer: {
      backgroundColor:
        tabValue === TextingPanelTabs.TEXTING_USAGE ||
        tabValue === TextingPanelTabs.SETTINGS
          ? Colors.WHITE1
          : Colors.WHITE,
      paddingInline: 30,
      paddingTop: 30,
      height: "100%",
    },
  };

  const newMassTextOnPress = useCallback(
    (campaignId?: string) => {
      if (campaignId) {
        navigate(onCampaignNavigatePath(campaignId), {
          state: { campaignId: campaignId, isFollowUp: true },
        });
      } else {
        setSelectedTextType({ massText: undefined, isVisible: true });
      }
    },
    [navigate]
  );

  return (
    <CreatorModePanelWrapper
      title="Texting"
      headerRight={
        <div className="AlignedRow" style={{ gap: 14 }}>
          <MarkitPlusActionButton />
          <RectangleButtonCreatorPanel
            title="New Text"
            iconName="ion:create"
            rightIcon={
              <OnboardingFlowDot
                flowTypes={[OnboardingFlowType.SEND_FIRST_TEXT]}
              />
            }
            onPress={() =>
              setSelectedTextType({ massText: undefined, isVisible: true })
            }
          />
        </div>
      }
      headerTabs={{
        tabNames: ["Campaigns", "Automations", "Texting Usage", "Settings"],
        tabValue: tabValue,
        setTabValue: setTabValue,
      }}
    >
      <div style={styles.textingPanelMainContentContainer}>
        <CampaignsListPanel
          tabValue={tabValue}
          newMassTextOnPress={newMassTextOnPress}
        />
        <TabPanel value={tabValue} index={1}>
          <AutomationsListPanel tabValue={tabValue} />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <TextingPanelUsage />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <TextingSettingsPanel />
        </TabPanel>
      </div>
      {/* Mass Texts Popup Panel */}
      {selectedTextType.isVisible ? (
        <MassTextPanel
          wrapperType={MassTextsWrapperType.MODAL}
          selectedTextType={selectedTextType}
          setSelectedTextType={setSelectedTextType}
          campaign={undefined}
        />
      ) : null}
    </CreatorModePanelWrapper>
  );
};

export default TextingPanel;
